import { ApiConsumes, ApiHeader, ApiOperation, ApiParam, ApiQuery, ApiTags } from '@nestjs/swagger';
import { errorHandler } from '@gtpl/shared-utils/error-messages';
import { Controller, Post, Body, Req, Query, UseInterceptors, UploadedFiles, Get, Param, Res} from '@nestjs/common';
import { ChayuthaService } from './kchayutha.service';
import { ChayuthaDTO, DeleteDTO, StatusDto } from './dto/kchayutha.dto';
import { AllChayuthaResponseModel, ChayuthaResponseModel, SingleChayuthaResponseModel } from './dto/kchayutha-response-model';


@ApiTags('chayutha')
@Controller('chayutha')
export class ChayuthaController {
  constructor(
    private chayuthaService: ChayuthaService
  ){}

  @ApiHeader({
    name:'Authorization',
    description:'Authorization token'
  })  
  @Post('/createChayutha') 
  @ApiQuery({name:'apiVersion'})  
  async createChayutha(@Query() queryParam,@Body() cyDto:ChayuthaDTO,@Req() request:Request): Promise<ChayuthaResponseModel> {
    try {
        return await this.chayuthaService.createChayutha(queryParam, cyDto);                
      } catch (error) {
          return errorHandler(ChayuthaResponseModel, error);
      }
  }

  @ApiHeader({
    name:'Authorization',
    description:'Authorization token'
  })
  @Post('/updateChayutha')
  @ApiQuery({name:'apiVersion'})  
  async updateChayutha(@Query() queryParams, @Body() cyDto:ChayuthaDTO, @Req() request: Request): Promise<SingleChayuthaResponseModel> {
    try {              
      return await this.chayuthaService.updateChayutha(queryParams, cyDto, request);
    } catch (error) {
      return errorHandler(SingleChayuthaResponseModel, error);
    }
  } 

  @ApiHeader({
    name:'Authorization',
    description:'Authorization token'
  })  
  @Get('/getAllChayutha/:userId')
  @ApiOperation({summary:'get list with filter - type means: all = 0, Yet to start = 1 , In progress  = 2, Completed =3'})
  @ApiQuery({name:'apiVersion'})
  @ApiQuery({name:'skip'})
  @ApiQuery({name:'type'})
  @ApiParam({name:'userId'})
  async getAllChayutha(@Query() queryParams, @Param('userId') userId, @Req() request:Request): Promise<AllChayuthaResponseModel> {
    try {
      return await this.chayuthaService.getAllChayutha(queryParams,userId,request);
    } catch (error) {
      return errorHandler(AllChayuthaResponseModel, error);
    }
  }

  @ApiHeader({
    name:'Authorization',
    description:'Authorization token'
  })  
  @Get('/getChayuthaById/:Id')
  @ApiQuery({name:'apiVersion'})
  @ApiParam({name:'Id'})
  async getChayuthaById(@Query() queryParams, @Param('Id') Id, @Req() request:Request): Promise<SingleChayuthaResponseModel> {
    try {
      return await this.chayuthaService.getChayuthaById(queryParams,Id,request);
    } catch (error) {
      return errorHandler(SingleChayuthaResponseModel, error);
    }
  }
 

  @ApiHeader({
    name:'Authorization',
    description:'Authorization token'
  })  
  @Post('/deleteRecord')
  @ApiQuery({name:'apiVersion'})
  async deleteRecord(@Query() queryParams, @Body() deleteDto:DeleteDTO ,@Req() request:Request): Promise<ChayuthaResponseModel> {
    try {
      return await this.chayuthaService.deleteRecord(queryParams,deleteDto, request);
    } catch (error) {
      return errorHandler(ChayuthaResponseModel, error);
    }
  }

@ApiHeader({
    name:'Authorization',
    description:'Authorization token'
})  
  @Post('/changeStatus')
  @ApiQuery({name:'apiVersion'})
  async changeWelfareStatus(@Query() queryParams, @Body() statusDto:StatusDto ,@Req() request:Request): Promise<SingleChayuthaResponseModel> {
    try {
      return await this.chayuthaService.changeWelfareStatus(queryParams,statusDto, request);
    } catch (error) {
      return errorHandler(SingleChayuthaResponseModel, error);
    }
  }



} 
